/**
 * Query key that opens the « Prendre un rendez-vous » hub as soon as the
 * patient file is displayed.
 *
 * It is how the detection pop-up hands over: the pop-up cannot host the hub
 * (its window is sized to its own content), so it sends the main window to
 * the patient file with this flag, and the file opens the hub on arrival. The
 * hub removes the key when it closes, so a reload does not reopen it.
 */
export const APPOINTMENT_SHORTCUT_QUERY_KEY = 'appointment';
